import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Icon } from 'react-icons-kit'
import Search from 'react-icons-kit/icomoon/search'
// import AccountCircle from '@mui/icons-material/AccountCircle';

const CssTextField = withStyles({
  root: {
    '& .MuiInputLabel-formControl': {
      top: '-2px'
    },
    '& label.Mui-focused': {
      color: '#528b46',


    },
    '& .MuiInput-underline:after': {
      borderColor: '#528b46',
      borderRadius: '1'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#528b46',
        borderRadius: '1'
      },
      '&:hover fieldset': {
        borderColor: '#528b46',
        borderRadius: '1',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#528b46',
        borderRadius: '1'
      },
      height: '30px',
      maxHeight: '30px'
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    marginRight: '6px',
    marginBottom: '10px'
  },
}));

export default function CustomizedInputs(props) {
  const classes = useStyles();


  return (
    <>

      <CssTextField
        className={classes.margin}
        label={props.label}
        variant={props.variant}
        id={props.id}
        size={props.size}
        name={props.name}
        autoFocus={false}
        inputProps={{
          maxLength: props.maxLength,
          pattern: props.pattern,
        }}
        InputProps={{
          startAdornment: props.startAdornment ? <InputAdornment position="start">{props.startAdornment}</InputAdornment> : '',
          endAdornment: props.endAdornment ? <InputAdornment style={{ width: '5px', marginRight: '-2px', marginLeft: '-2px' }} position="end">{props.endAdornment}</InputAdornment> : '',
        }}
        {...props}
      />

    </>
  );
}